import { h, Component } from 'preact';
import classNames from 'classnames';
import styles from './submit_button_style';

let cx = classNames.bind(styles);

export default class SubmitButton extends Component {
	render({field, submitting}, {}) {
		var sizeClass = cx({
      field: true,
      Small: field.size === 'Small',
			Medium: field.size === 'Medium',
			Large: field.size === 'Large',
      XLarge: field.size === 'XLarge',
      submitButtonContainer: true
    });
		let button = null;
		if(this.props.submitting) {
			button = <input class="btn btn-primary" type="submit" value='Submitting' disabled='disabled' />;
		} else {
			button = <input class="btn btn-primary" type="submit" value={field.label} />;
		}
		return (
			<div class={sizeClass}>
				{button}
      </div>
		);
	}
}



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/src/components/form/submit_button.js